import { Grid, Box } from '@chakra-ui/react'
import { FC, useMemo, useEffect } from 'react'

import useStoreBudget from '@hook/budget/use-store'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import LayoutTools from '@component/Layout/Tools'

import { disableActionsByDefault } from '@helper/budget/store/disableActionsByDefault'
const ConciliationBudget: FC = () => {
  const { menuToggle } = useLayout()
  const { getFilters } = useFilters()
  const {
    loading,
    headers,
    actions,
    data,
    filename,
    dataFooter,
    handleLocalParams,
    params,
    query,
    pagination,
    dataUpdate,
    saveUpdate,
    filters,
    setFilters,
    getData,
    filtersList,
    clearAllFilters,
    handleUpdateParams
  } = useStoreBudget()

  const { hasSessions } = useSessions()

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )

  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 187px)'
          : 'calc(100vh - 155px)'
        : hasSessions
        ? 'calc(100vh - 328px)'
        : 'calc(100vh - 296px)',
    [menuToggle, hasSessions]
  )

  useEffect(() => {
    handleLocalParams()
    data?.length === 0 && getData()

    getFilters({
      companies: true,
      centers: true,
      compactCategories: true,
      yearBudget: true,
      monthBudget: true,
      historicBudget: true,
      operationBudget: true
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="Orçamento Loja">
      <Grid
        w="100vw"
        bg="white"
        h={height}
        templateColumns={!filters ? '100vw' : '260px calc(100vw - 260px)'}
      >
        {filters && (
          <LayoutFilters
            filters={filtersList}
            values={params}
            onChange={handleUpdateParams}
            loading={loading}
            canCancel={loading}
            onFilter={getData}
            onClearAllFilters={clearAllFilters}
          />
        )}
        <Box>
          <LayoutTools
            title={filename}
            filters={filters}
            actions={actions}
            toggleFilters={setFilters.toggle}
            isDisabled={loading || data.length === 0}
            disableActionsByDefault={disableActionsByDefault}
          />
          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os registros no banco de dados"
            />
          ) : data.length === 0 ? (
            <LayoutEmpty
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          ) : (
            <>
              <GridQuantity
                data={data}
                textButton="Salvar"
                disabled={dataUpdate.length === 0}
                onClick={saveUpdate}
              />

              <TableGrid
                id="purchase-budget-store"
                headers={headers}
                data={data}
                height={tableHeight}
                itsSortable={true}
                entity="budget-store"
                dataFooter={dataFooter}
                isFooter={true}
                pagination={pagination}
                query={query}
                isPaged
              />
            </>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default ConciliationBudget
